// =============================================================================
// Notifications
// =============================================================================
export const NOTIFICATION_TYPES = [
    'task_complete',
    'needs_input',
    'error',
    'progress',
    'session_ended',
    'pr_created',
    'cron_failure',
    /** A project member @mentioned you in a session comment. */
    'mention',
    /** Someone commented on your session, or replied in a comment thread you are part of. */
    'comment',
    /** A session was shared with you, or your shared access to it was removed. */
    'session_access',
];
export const NOTIFICATION_URGENCIES = ['high', 'medium', 'low'];
export const NOTIFICATION_CHANNELS = ['in_app', 'web_push'];
//# sourceMappingURL=notification.js.map